import React, { useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import LoginPageWrapper from '../Components/LoginPageWrapper';
import LoginFormHeader from '../Components/LoginFormHeader';

import './Organization.scss';

const spinnerId = 'organizationForm';

function Organization(props) {
  const { isLoading, response, login, goToLoginPage } = props;

  useEffect(() => {
    if (!response) {
      goToLoginPage();
    }
    // eslint-disable-next-line
  }, []);

  const availablePaths = get(response, 'data.availablePaths', []);

  return (
    <LoginPageWrapper className="react-page-organization-page" mainAriaLabel="Organization selection screen">
      <div className="organization-page-form-wrapper u-els-background-color-background">
        {isLoading && <SimpleSpinner id={spinnerId} />}
        <LoginFormHeader
          subtitleText="Welcome to Reaxys Choice Screen"
          descriptionMessage="To sign in please select one of the departments below:"
          headerText="Sign in"
        />
        <ul className="u-els-line-height-default">
          {availablePaths.map((data) => (
            <li key={data.label} className="u-els-margin-bottom-1o2">
              <LinkElement
                data-e2e="select-organization"
                href="#"
                iconSprite="ChevronRight"
                iconSize="xs"
                className="e2e-select-organization"
                isExternal
                onClick={(e) => {
                  e.preventDefault();
                  login(data.id);
                }}>
                {data.label || ''}
              </LinkElement>
            </li>
          ))}
        </ul>
      </div>
    </LoginPageWrapper>
  );
}

Organization.propTypes = {
  isLoading: PropTypes.bool,
  response: PropTypes.object,
  login: PropTypes.func.isRequired,
  goToLoginPage: PropTypes.func.isRequired,
};

export default Organization;
